import { render } from "./ic-grafic.vue?vue&type=template&id=d11e27ae&ts=true"
import script from "./ic-grafic.vue?vue&type=script&lang=ts"
export * from "./ic-grafic.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__